import extendNode from '../extendNode.mjs'
import useCategoryNode from '../_CATEGORY/useCategoryNode.jsx'
import meta from './metaUiUe.mjs'

export default () => {
    const CategoryNode = useCategoryNode()

    return extendNode(CategoryNode, {
        ...meta,

        canMountType(map, node, type) {
            return /^(CAT|UE)$/.test(type)
        },

        menuItemsInsertCommon(map, node) {
            return [
                {type: 'CAT'},
            ]
        },

        menuItemsInsertConcept(map, node) {
            return [
                {type: 'UE'},
            ]
        },
    })
}
